import { WorkflowStepsBaseService } from "app/core/workflow/workflow-steps/workflow-steps-base.service";
import { UpsellPageComponentPath } from "../../page-path/statement-page-path/upsell-page-component.path ";

export class WorkflowUpsellPageService extends WorkflowStepsBaseService {
  public get isRequired(): boolean {
    return false;
  }

  public get isBlocked(): boolean {
    if (this.statement.isPremiumPackage) return true;

    return !this.statement.isPercentagePaymentAllowed; //if is not allowed we want to skip this page
  }

  public get urlRegex(): RegExp {
    return UpsellPageComponentPath.regex();
  }

  public get url(): string {
    return UpsellPageComponentPath.url(this.getStatementId);
  }
}
